import {ImgButton} from '../../core/button'
import {CalendarIcon, ReminderIcon} from '../../../icons'
import {useState} from 'react'
import ReminderPopup from './ReminderPopup'
import Modal from '../../core/modal'
import renderSkeletonLoaders from '../../../utils/loader'
import classNames from 'classnames'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const SslSection = ({type, setButtonEnabled, data, title, body, isDataFetching, isDataLoading, isDarkMode}) => {
    const [isModalActive, setIsModalActive] = useState(false)

    const text = useNamespaceTranslations('monitoring')

    const closeModal = () => {
        setIsModalActive(false)
    }

    return (
        <>
            <Modal isOpen={setButtonEnabled && isModalActive} className={classNames('reminder-modal', {
                dark: isDarkMode
            })} closeModal={closeModal}>
                <ReminderPopup type={type} data={data} closeModal={closeModal}/>
            </Modal>
            <div className={classNames('ssl-section', {
                'dark': isDarkMode
            })}>
                <>
                    <div className="header">
                        {(!isDataFetching || isDataLoading)  && <h4 className="title">{title}</h4>}
                        {
                            !isDataFetching && !isDataLoading &&
                            setButtonEnabled &&
                                <ImgButton className={classNames({
                                    'light-bg': !isDarkMode
                                })} onClick={() => setIsModalActive(true)}>
                                    <span className="text">{data ? text.view_reminder : text.set_reminder}</span>
                                    {data ? <CalendarIcon/> : <ReminderIcon/>}
                                </ImgButton>
                        }
                    </div>
                    {isDataLoading  ? (
                        <span className="getting-data">
                            {text.getting_ssl_and_domain}
                        </span>
                    ) :
                        isDataFetching ? <span className='content-body-loading'>{renderSkeletonLoaders(7)}</span> :
                            body}
                </>
            </div>
        </>
    )
}

export default SslSection
